/* Print Phuket signature navigation (14 Oct 2026).
   Takes over the theme's menu button: opens the PP panel instead of the old white drawer.
   If this script fails, the theme's own drawer still works (no-JS fallback). */
(function () {
  'use strict';
  var root = document.getElementById('PPNav');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var html = document.documentElement;
  var sheet = root.querySelector('.ppn__sheet');
  var tabs = [].slice.call(root.querySelectorAll('[data-ppn-tab]'));
  var views = [].slice.call(root.querySelectorAll('[data-ppn-view]'));
  var ind = root.querySelector('.ppn__ind');
  var mqDesk = window.matchMedia('(min-width: 1024px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lastTrigger = null;
  var hoverTimer = null;
  var closeTimer = null;

  function track(event, data) {
    try {
      var payload = Object.assign({ event: event }, data || {});
      (window.dataLayer = window.dataLayer || []).push(payload);
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(event, data || {});
    } catch (e) {}
  }

  /* ---------- trigger buttons (theme's menu buttons) ---------- */
  var label = root.dataset.triggerLabel || '';
  function triggers() { return [].slice.call(document.querySelectorAll('.menu-drawer-button')); }
  triggers().forEach(function (b) {
    b.classList.add('ppn-trigger');
    b.setAttribute('aria-controls', 'PPNav');
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-haspopup', 'dialog');
    b.setAttribute('aria-label', 'Open menu');
    if (label && !b.querySelector('.ppn-trigger__label')) {
      var s = document.createElement('span');
      s.className = 'ppn-trigger__label';
      s.setAttribute('aria-hidden', 'true');
      s.textContent = label;
      b.appendChild(s);
    }
  });

  /* Prime images on intent so the first open is instant, but nothing loads on page view */
  function prime() { if (root.hasAttribute('hidden')) root.removeAttribute('hidden'); }
  document.addEventListener('pointerover', function (e) { if (e.target.closest && e.target.closest('.menu-drawer-button')) prime(); }, { passive: true });
  document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest('.menu-drawer-button')) prime(); });
  document.addEventListener('touchstart', function (e) { if (e.target.closest && e.target.closest('.menu-drawer-button')) prime(); }, { passive: true });

  /* Capture-phase: beat the theme's own drawer handler */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.menu-drawer-button');
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    root.classList.contains('is-open') ? close() : open(b);
  }, true);

  function headerBottom() {
    var h = document.querySelector('.shopify-section-group-header-group header, sticky-header, .header');
    var wrap = h && (h.closest('.shopify-section') || h);
    var r = wrap ? wrap.getBoundingClientRect() : null;
    return r ? Math.max(0, Math.round(r.bottom)) : 0;
  }
  function placeSheet() { root.style.setProperty('--ppn-top', mqDesk.matches ? headerBottom() + 'px' : '0px'); }

  function open(btn) {
    clearTimeout(closeTimer);
    prime();
    lastTrigger = btn || lastTrigger;
    placeSheet();
    showTab(activeIndex(), false);
    resetDrill(true);
    // next frame so the transition runs
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      html.classList.add('ppn-open');
      triggers().forEach(function (b) { b.setAttribute('aria-expanded', 'true'); b.setAttribute('aria-label', 'Close menu'); });
      setInd();
      var first = mqDesk.matches ? root.querySelector('.ppn__tab[aria-expanded="true"]') : root.querySelector('.ppn__close');
      try { (first || sheet).focus({ preventScroll: true }); } catch (e) {}
    });
    track('pp_nav_open', { viewport: mqDesk.matches ? 'desktop' : 'mobile' });
  }
  function close(noFocus) {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    html.classList.remove('ppn-open');
    hideResults();
    triggers().forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', 'Open menu'); });
    closeTimer = setTimeout(function () { resetDrill(true); }, reduce.matches ? 0 : 420);
    if (!noFocus && lastTrigger && lastTrigger.offsetParent) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
  }
  root.querySelectorAll('[data-ppn-close]').forEach(function (el) { el.addEventListener('click', function () { close(); }); });

  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      if (!resultsBox.hidden) { hideResults(); input.focus(); return; }
      if (!mqDesk.matches && root.querySelector('.ppn__view.is-drill')) { resetDrill(); return; }
      close(); return;
    }
    if (e.key === 'Tab') trapFocus(e);
  });
  function focusables() {
    var scope = (!mqDesk.matches && root.querySelector('.ppn__view.is-drill')) || sheet;
    return [].slice.call(scope.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),select')).filter(function (el) {
      return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function trapFocus(e) {
    var f = focusables();
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === a || !sheet.contains(document.activeElement))) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && (document.activeElement === z || !sheet.contains(document.activeElement))) { e.preventDefault(); a.focus(); }
  }

  /* Close when a link inside is followed (same-page anchors, bfcache) */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var area = a.getAttribute('data-ppn-track') || 'link';
    track('pp_nav_click', { area: area, label: (a.textContent || '').trim().slice(0, 80), href: a.getAttribute('href') });
    if (area === 'card' || area === 'chip') track('pp_cta_click', { cta: 'nav-' + area, label: (a.textContent || '').trim(), href: a.getAttribute('href'), location: 'nav' });
    if (!(e.metaKey || e.ctrlKey || e.shiftKey)) setTimeout(function () { close(true); }, 60);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(true); });
  window.addEventListener('resize', function () {
    if (!root.classList.contains('is-open')) return;
    placeSheet(); setInd();
  });
  mqDesk.addEventListener && mqDesk.addEventListener('change', function () { if (root.classList.contains('is-open')) close(true); });

  /* ---------- tabs (desktop) / drill-down (phone) ---------- */
  function activeIndex() {
    for (var i = 0; i < tabs.length; i++) if (tabs[i].getAttribute('aria-expanded') === 'true') return i;
    return 0;
  }
  function showTab(i, fromUser) {
    tabs.forEach(function (t, n) { t.setAttribute('aria-expanded', n === i ? 'true' : 'false'); });
    views.forEach(function (v, n) { v.classList.toggle('is-active', n === i); });
    setInd();
    if (fromUser) track('pp_nav_tab', { tab: (tabs[i] && tabs[i].textContent || '').trim() });
  }
  function setInd() {
    if (!ind || !mqDesk.matches) return;
    var t = tabs[activeIndex()];
    if (!t) return;
    ind.style.setProperty('--ind-y', t.parentNode.offsetTop + 'px');
    ind.style.setProperty('--ind-h', t.offsetHeight + 'px');
  }
  function drill(i) {
    var v = views[i];
    if (!v) return;
    clearTimeout(closeTimer);
    v.classList.add('is-drill');
    tabs[i].setAttribute('aria-expanded', 'true');
    v.scrollTop = 0;
    setTimeout(function () { var b = v.querySelector('[data-ppn-back]'); if (b) b.focus({ preventScroll: true }); }, reduce.matches ? 0 : 60);
    track('pp_nav_tab', { tab: (tabs[i].textContent || '').trim() });
  }
  function resetDrill(silent) {
    var v = root.querySelector('.ppn__view.is-drill');
    if (!v) return;
    v.classList.remove('is-drill');
    var i = views.indexOf(v);
    if (!mqDesk.matches && tabs[i]) {
      tabs[i].setAttribute('aria-expanded', 'false');
      if (!silent) tabs[i].focus({ preventScroll: true });
    }
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      if (mqDesk.matches) showTab(i, true);
      else drill(i);
    });
    // hover intent on desktop: switch only after the pointer rests, so diagonal moves don't flicker
    t.addEventListener('pointerenter', function (e) {
      if (!mqDesk.matches || e.pointerType !== 'mouse') return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { if (activeIndex() !== i) showTab(i, true); }, 140);
    });
    t.addEventListener('pointerleave', function () { clearTimeout(hoverTimer); });
    t.addEventListener('keydown', function (e) {
      if (!mqDesk.matches) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var n = (i + (e.key === 'ArrowDown' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[n].focus(); showTab(n, true);
      }
    });
  });
  root.querySelectorAll('[data-ppn-back]').forEach(function (b) { b.addEventListener('click', function () { resetDrill(); }); });

  /* ---------- search (phone menu) + synonyms ---------- */
  var form = root.querySelector('[data-ppn-search]');
  var input = form ? form.querySelector('input[type=search]') : null;
  var resultsBox = root.querySelector('#PPNavResults') || { hidden: true };
  var suggestUrl = (root.dataset.suggestUrl || '/search/suggest') + '.json';
  var searchUrl = root.dataset.searchUrl || '/search';
  var rules = (root.dataset.synonyms || '').split(/\n/).map(function (line) {
    var p = line.split('=>');
    if (p.length < 2) return null;
    var to = p[1].trim().toLowerCase();
    var from = p[0].split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean)
      .sort(function (a, b) { return b.length - a.length; });
    return to && from.length ? { from: from, to: to } : null;
  }).filter(Boolean);

  function expand(q) {
    var low = (q || '').toLowerCase().trim();
    if (!low) return q;
    for (var r = 0; r < rules.length; r++) {
      for (var f = 0; f < rules[r].from.length; f++) {
        var w = rules[r].from[f];
        var re = new RegExp('(^|\\s)' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(\\s|$)');
        if (re.test(low) && low.indexOf(rules[r].to) === -1) return q.trim() + ' OR ' + rules[r].to;
      }
    }
    return q;
  }
  window.ppnExpandQuery = expand;

  /* Apply the same synonyms to every other search form on the site (header search, search page) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || f === form) return;
    var act = f.getAttribute('action') || '';
    if (act.indexOf(searchUrl) !== 0 && act.indexOf('/search') === -1) return;
    var q = f.querySelector('input[name="q"]');
    if (q && q.value) {
      var x = expand(q.value);
      if (x !== q.value) { track('pp_search_synonym', { term: q.value, expanded: x, source: 'site' }); q.value = x; }
    }
  }, true);

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hideResults() { if (resultsBox && resultsBox.nodeType) { resultsBox.hidden = true; resultsBox.innerHTML = ''; if (input) input.removeAttribute('aria-expanded'); } }

  var cards = [].slice.call(root.querySelectorAll('.ppn__card')).map(function (c) {
    var a = c.querySelector('.ppn__name');
    var img = c.querySelector('img');
    return { el: c, name: (a.textContent || '').trim(), href: a.getAttribute('href'), terms: c.getAttribute('data-ppn-terms') || '', img: img ? (img.currentSrc || img.getAttribute('src')) : '' };
  });
  function matchCards(q) {
    var words = q.toLowerCase().replace(/ or /g, ' ').split(/\s+/).filter(function (w) { return w.length > 1; });
    if (!words.length) return [];
    var seen = {}, best = 0;
    var scored = cards.map(function (c) {
      var name = c.name.toLowerCase(), score = 0;
      words.forEach(function (w) {
        var stem = w.replace(/(ies|es|s)$/, '');
        var k = stem.length > 2 ? stem : w;
        if (name.indexOf(k) !== -1) score += 3;
        else if (c.terms.indexOf(k) !== -1) score += 1;
      });
      if (score > best) best = score;
      return { c: c, s: score };
    });
    return scored.filter(function (x) { return x.s > 0 && x.s >= best * 0.6; })
      .sort(function (a, b) { return b.s - a.s; })
      .map(function (x) { return x.c; })
      .filter(function (c) { if (seen[c.href]) return false; seen[c.href] = 1; return true; })
      .slice(0, 3);
  }

  var timer = null, seq = 0;
  function runSearch() {
    var raw = input.value.trim();
    if (raw.length < 2) { hideResults(); return; }
    var q = expand(raw);
    var my = ++seq;
    var url = suggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
      if (my !== seq) return;
      var res = (d && d.resources && d.resources.results) || {};
      var prods = (res.products || []).slice(0, 5);
      var cats = matchCards(q);
      var cHandles = cats.map(function (c) { return c.href; });
      (res.collections || []).forEach(function (c) {
        if (cats.length < 3 && cHandles.indexOf(c.url.split('?')[0]) === -1 && !/multibuy|frontpage|best-sellers/.test(c.handle)) {
          cats.push({ name: c.title, href: c.url.split('?')[0], img: c.featured_image && c.featured_image.url ? c.featured_image.url + (c.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96' : '' });
          cHandles.push(c.url.split('?')[0]);
        }
      });
      var h = '';
      if (cats.length) {
        h += '<p class="ppn__rh">Categories</p>';
        cats.forEach(function (c) { h += '<a class="ppn__ri" data-ppn-track="search-category" href="' + esc(c.href) + '">' + (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy">' : '<span class="ppn__rdot"></span>') + '<span>' + esc(c.name) + '</span></a>'; });
      }
      if (prods.length) {
        h += '<p class="ppn__rh">Products</p>';
        prods.forEach(function (p) {
          var src = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96' : '';
          h += '<a class="ppn__ri" data-ppn-track="search-product" href="' + esc(p.url.split('?')[0]) + '">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '<span class="ppn__rdot"></span>') + '<span>' + esc(p.title) + (p.type ? '<small>' + esc(p.type) + '</small>' : '') + '</span></a>';
        });
      }
      if (!cats.length && !prods.length) h += '<p class="ppn__rnone">No products match “' + esc(raw) + '”. Try another word, or ask us for a quote.</p>';
      h += '<a class="ppn__rall" data-ppn-track="search-all" href="' + esc(searchUrl + '?q=' + encodeURIComponent(q) + '&options[prefix]=last') + '">See all results for “' + esc(raw) + '”</a>';
      resultsBox.innerHTML = h;
      resultsBox.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      track('pp_nav_search', { term: raw, expanded: q !== raw ? q : '', products: prods.length, categories: cats.length });
    }).catch(function () {});
  }
  if (input) {
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(runSearch, 220); });
    input.addEventListener('focus', function () { if (input.value.trim().length > 1 && resultsBox.hidden) runSearch(); });
    form.addEventListener('submit', function () {
      var x = expand(input.value);
      if (x !== input.value) input.value = x;
      track('pp_nav_search_submit', { term: input.value });
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hideResults(); });
  }

  /* ---------- business finder (tabs with many cards) ---------- */
  root.querySelectorAll('[data-ppn-filter]').forEach(function (f) {
    var view = f.closest('.ppn__view');
    var items = [].slice.call(view.querySelectorAll('.ppn__card'));
    var none = view.querySelector('[data-ppn-filter-none]');
    var t = null;
    function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    f.addEventListener('input', function () {
      var words = norm(f.value).trim().split(/\s+/).filter(function (w) { return w.length > 1; });
      var n = 0;
      items.forEach(function (c) {
        var terms = norm(c.getAttribute('data-ppn-terms'));
        var ok = !words.length || words.every(function (w) { var s = w.replace(/(ies|es|s)$/, ''); return terms.indexOf(s.length > 2 ? s : w) !== -1; });
        c.hidden = !ok; if (ok) n++;
      });
      if (none) none.hidden = n > 0;
      clearTimeout(t);
      if (words.length) t = setTimeout(function () { track('pp_nav_business_find', { term: f.value.trim(), results: n }); }, 800);
    });
    f.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); var first = items.filter(function (c) { return !c.hidden; })[0]; if (first) { var a = first.querySelector('a'); if (a) a.click(); } }
      if (e.key === 'Escape' && f.value) { e.stopPropagation(); f.value = ''; f.dispatchEvent(new Event('input')); }
    });
  });

  /* ---------- language selector ---------- */
  var lang = root.querySelector('[data-ppn-lang]');
  if (lang) lang.addEventListener('change', function () { lang.form.submit(); });
})();
